import Dropdown from 'rc-dropdown'
import 'rc-dropdown/assets/index.css'
import { DropdownProps } from 'rc-dropdown/lib/Dropdown'
import Menu, { Item as MenuItem } from 'rc-menu'
import { ReactNode, useState } from 'react'
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md'

import { ButtonRebrand } from 'src/components/atoms/ButtonRebrand'
import { InternalLink, OnClickLink } from 'src/components/atoms/Link'

export interface Action {
  avatar?: JSX.Element
  href?: string
  onClick?: () => void
  style?: string
  text: string
  icon?: JSX.Element
  isSeperator?: boolean
  disabled?: boolean
}

export interface ActionsDropdownProps {
  ButtonComponent?: React.FC
  actions: Action[]
  buttonComponentProps?: any
  children?: ReactNode
  className?: string
  dropdownTrigger?: DropdownProps['trigger']
  linkProps?: any
  hideChevron?: boolean
}

export const ActionsDropdown = ({
  ButtonComponent = ButtonRebrand,
  actions,
  buttonComponentProps,
  children,
  className = '',
  dropdownTrigger = 'click',
  linkProps,
  hideChevron = false
}: ActionsDropdownProps) => {
  const [visible, setVisible] = useState<boolean>(false)

  const renderMenuItem = (action: Action, idx: number) => {
    if (action.isSeperator) {
      return <Menu.Divider key={`divider-${idx}`} />
    }

    if (action.href) {
      return (
        <MenuItem
          disabled={action.disabled}
          key={action.text}
          className={`${action.disabled ? '' : 'hover:bg-limeBright/20!'} ${
            action.style || ''
          }`}
        >
          {action.disabled ? (
            <span className='text-cloudGrey font-medium cursor-default'>
              {action.text}
              {action.icon}
            </span>
          ) : (
            <InternalLink
              color='none'
              className='flex flex-row justify-between items-center w-full text-forestDeep'
              href={action.href}
              {...linkProps}
            >
              {action.avatar ? (
                <span className='mr-2 h-6'>{action.avatar}</span>
              ) : null}
              {action.text}
              {action.icon}
            </InternalLink>
          )}
        </MenuItem>
      )
    }
    return (
      <MenuItem
        key={action.text}
        className={`${action.disabled ? '' : 'hover:bg-limeBright/20!'} ${
          action.style || ''
        }`}
        disabled={action.disabled}
      >
        {action.disabled ? (
          <span className='text-cloudGrey font-medium cursor-default'>
            {action.text}
            {action.icon}
          </span>
        ) : (
          <OnClickLink
            color='forestDeep'
            className='flex flex-row justify-between items-center w-full'
            onClick={action.onClick}
            {...linkProps}
          >
            {action.avatar ? (
              <span className='mr-2 h-6'>{action.avatar}</span>
            ) : null}
            {action.text}
            {action.icon}
          </OnClickLink>
        )}
      </MenuItem>
    )
  }

  return (
    <Dropdown
      animation='slide-up'
      onVisibleChange={() => setVisible(!visible)}
      placement='bottomRight'
      trigger={dropdownTrigger}
      visible={visible}
      overlay={<Menu>{actions.map((a, i) => renderMenuItem(a, i))}</Menu>}
    >
      <div className={className}>
        <ButtonComponent {...buttonComponentProps}>
          <div className='flex items-center'>
            {children}
            {!hideChevron && (
              <span className='ml-1 mr[-4px]'>
                {visible ? (
                  <MdKeyboardArrowUp size='20px' />
                ) : (
                  <MdKeyboardArrowDown size='20px' />
                )}
              </span>
            )}
          </div>
        </ButtonComponent>
      </div>
    </Dropdown>
  )
}
